import request from "../utils/request";

export const getPositions = (type: number) => '/position/?type=' + type

export function modifyPosition(data: any) {
    return request.request({
        url: '/position/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}
